import React from "react";

export default function Mint({
  size,
  ...rest
}: {
  size: number;
  [x: string]: any;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M17.8309 5.64122H20V3.76068H16.6019C15.907 2.61107 14.9355 1.66203 13.7799 1.00379C12.6243 0.34555 11.323 0 9.99967 0C8.67634 0 7.375 0.34555 6.21941 1.00379C5.06381 1.66203 4.09238 2.61107 3.39748 3.76068H0V5.64122H2.56573C2.13182 7.11521 2.12728 8.68621 2.55268 10.1628H0V12.0433H3.37008C4.06208 13.2053 5.03553 14.1658 6.19667 14.8324C7.35781 15.4989 8.66752 15.8491 9.99967 15.8491C11.3318 15.8491 12.6415 15.4989 13.8027 14.8324C14.9638 14.1658 15.9373 13.2053 16.6293 12.0433H20V10.1628H17.4473C17.873 8.68622 17.8683 7.11506 17.4336 5.64122H17.8309ZM10.0026 13.1854C8.98332 13.1854 7.98692 12.8768 7.13941 12.2988C6.2919 11.7207 5.63134 10.8991 5.24128 9.93783C4.85121 8.97656 4.74915 7.91881 4.948 6.89833C5.14686 5.87784 5.63769 4.94047 6.35844 4.20475C7.07919 3.46902 7.99748 2.96799 8.99719 2.765C9.99689 2.56202 11.0331 2.66619 11.9748 3.06437C12.9165 3.46254 13.7214 4.13682 14.2877 5.00194C14.854 5.86706 15.1562 6.88417 15.1562 7.92464C15.1547 9.31985 14.6109 10.6574 13.6441 11.6437C12.6774 12.63 11.3668 13.1845 10 13.1854H10.0026ZM10.0026 6.11136C10.3539 6.11136 10.6974 6.2177 10.9895 6.41695C11.2816 6.6162 11.5093 6.89939 11.6438 7.23073C11.7782 7.56206 11.8134 7.92665 11.7448 8.2784C11.6763 8.63014 11.5071 8.95324 11.2587 9.20683C11.0103 9.46042 10.6937 9.63312 10.3492 9.70308C10.0046 9.77305 9.64741 9.73714 9.32282 9.5999C8.99823 9.46265 8.7208 9.23024 8.52561 8.93205C8.33042 8.63386 8.22624 8.28328 8.22624 7.92464C8.22624 7.44419 8.41303 6.98338 8.7456 6.6434C9.07817 6.30342 9.52933 6.11206 10 6.11136H10.0026Z"
        fill="#EBEBEC"
      />
    </svg>
  );
}
